import React from 'react';
import PropTypes from 'prop-types';

const CircleWithText = ({circleWithTextData}) => {

    CircleWithText.propTypes = {
        circleWithTextData: PropTypes.shape({
            circleColor: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired
        }),
    };

    return (
        <div className="circleWithText">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 viewBox="0 0 16 16"
                 fill="none">
                <circle cx="8" cy="8" r="8" fill={circleWithTextData.circleColor}></circle>
            </svg>
            <div>{circleWithTextData.text}</div>
        </div>
    );
};

export default CircleWithText;